import colors from "./colors";

const theme = {
  token: {
    colorPrimary: colors.green,
    colorSuccess: colors.lightGreen,
    colorWarning: colors.yellow,
    colorError: "#E74C3C",

    colorBgLayout: colors.bgSoft,
    colorBgContainer: colors.white,

    borderRadius: 8,
    fontFamily: "Inter, system-ui, sans-serif",
  },
};

export default theme;
